export default __webpack_public_path__ + "static/media/img_session_three.19a23a65.jpg";